import { graphql } from 'graphql-schema';

const RESERVATION_RSVP_STATUS = graphql(`
  query ReservationRsvpStatus($reservationId: uuid!) {
    getReservationRoster(reservationId: $reservationId) {
      _id
      user {
        _id
        gender
        profile_picture
        display_name_teams
      }
      teamRole
    }
    rentalReservation: rental_reservations_by_pk(_id: $reservationId) {
      _id
      end_time
      reserving_user
      num_guests_estimate
      deep_link
    }
  }
`);

export default RESERVATION_RSVP_STATUS;
